import { render } from "./SearchTabs.vue?vue&type=template&id=4451beeb&scoped=true"
import script from "./SearchTabs.vue?vue&type=script&lang=js"
export * from "./SearchTabs.vue?vue&type=script&lang=js"

import "./SearchTabs.vue?vue&type=style&index=0&id=4451beeb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4451beeb"]])

export default __exports__